import {
  tranformFlotoScheduleForServer,
  transformFlotoSchedule,
} from '@data/report'
export function transformNetworkScan(networkScan) {
  return {
    id: networkScan.id,
    name: networkScan.name,
    ipRangeType: networkScan.ipRangeType,
    discoveryStatus: networkScan.discoveryStatus,
    discoveryDisabled: networkScan.discoveryDisabled,
    lastRunDate: networkScan.discoveryLastFiredTime,
    nextRunDate: networkScan.discoveryNextFireTime,
    pollingStatus: networkScan.pollingStatus,
    pollingLastRunDate: networkScan.pollingLastFiredTime,
    pollingNextRunDate: networkScan.pollingNextFireTime,
    pollingDisabled: networkScan.pollingDisabled,
    pingLastRunDate: networkScan.pingLastFiredTime,
    pingNextRunDate: networkScan.pingNextFireTime,
    pingDisabled: networkScan.pingDisabled,
    createdBy: networkScan.createdById,
    createdAt: networkScan.createdTime,
    location: networkScan.locationId,
    department: networkScan.departmentId,
    companyId: networkScan.companyId,
    // array to string
    excludeIpListInScan: (networkScan.excludeIpListInScan || []).join(','),
    hostResolutionType: networkScan.hostResolutionType,
    description: networkScan.description,
    credentialIds: networkScan.credentialIds,
    pollerId: networkScan.pollerId,
    type: networkScan.type,
    networkType: networkScan.networkType,
    discoverySchedule: {
      ...(networkScan.discoverySchedule
        ? transformFlotoSchedule({
            flotoSchedule: networkScan.discoverySchedule || {},
          })
        : {}),
    },
    pollingSchedule: {
      ...(networkScan.pollingSchedule
        ? transformFlotoSchedule({
            flotoSchedule: networkScan.pollingSchedule || {},
          })
        : {}),
    },
    pingSchedule: {
      ...(networkScan.pingSchedule
        ? transformFlotoSchedule({
            flotoSchedule: networkScan.pingSchedule || {},
          })
        : {}),
    },
    discoveryEmails: networkScan.discoveryEmails,
    pollingEmails: networkScan.pollingEmails,
    pingEmails: networkScan.pingEmails,
    addAssetToCmdb: networkScan.addAssetToCmdb,
    canDelete: networkScan.deleteableOob,
    canEdit: networkScan.updatebleOob,
    ...('ipRangeStart' in networkScan
      ? { ipRangeStart: networkScan.ipRangeStart }
      : {}),
    ...('ipRangeEnd' in networkScan
      ? {
          ipRangeEnd: networkScan.ipRangeEnd,
        }
      : {}),
    ...('ipList' in networkScan
      ? {
          ipList: (networkScan.ipList || []).join(','),
        }
      : {}),
  }
}

export function transformNetworkScanForServer(networkScan) {
  return {
    name: networkScan.name,
    ipRangeType: networkScan.ipRangeType,
    discoveryStatus: networkScan.discoveryStatus,
    discoveryDisabled: networkScan.discoveryDisabled,
    pollingStatus: networkScan.pollingStatus,
    pollingDisabled: networkScan.pollingDisabled,
    pingDisabled: networkScan.pingDisabled,
    discoveryLastFiredTime: networkScan.lastRunDate,
    discoveryNextFireTime: networkScan.nextRunDate,
    createdBy: networkScan.createdById,
    locationId: networkScan.location,
    departmentId: networkScan.department,
    companyId: networkScan.companyId,
    // string to array
    ...('excludeIpListInScan' in networkScan
      ? {
          excludeIpListInScan: (networkScan.excludeIpListInScan || '').split(
            ','
          ),
        }
      : {}),
    hostResolutionType: networkScan.hostResolutionType,
    description: networkScan.description,
    credentialIds: networkScan.credentialIds,
    ...(networkScan.discoverySchedule &&
    Object.keys(networkScan.discoverySchedule).length > 0
      ? {
          discoverySchedule: tranformFlotoScheduleForServer(
            networkScan.discoverySchedule
          ),
        }
      : {}),
    ...(networkScan.pollingSchedule &&
    Object.keys(networkScan.pollingSchedule).length > 0
      ? {
          pollingSchedule: tranformFlotoScheduleForServer(
            networkScan.pollingSchedule
          ),
        }
      : {}),
    ...(networkScan.pingSchedule &&
    Object.keys(networkScan.pingSchedule).length > 0
      ? {
          pingSchedule: tranformFlotoScheduleForServer(
            networkScan.pingSchedule
          ),
        }
      : {}),
    discoveryEmails: networkScan.discoveryEmails,
    pollingEmails: networkScan.pollingEmails,
    pingEmails: networkScan.pingEmails,
    addAssetToCmdb: networkScan.addAssetToCmdb,
    ...('ipRangeStart' in networkScan
      ? { ipRangeStart: networkScan.ipRangeStart }
      : {}),
    ...('ipRangeEnd' in networkScan
      ? {
          ipRangeEnd: networkScan.ipRangeEnd,
        }
      : {}),
    ...('ipList' in networkScan
      ? {
          ipList: (networkScan.ipList || '').split(','),
        }
      : {}),
    type: 'IpNetworkRest',
    networkType: 'ip_range_network',
    pollerId: networkScan.pollerId,
  }
}
